import { IDENTITY_AVAILABLE_STATUS, IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';
import TikTokIcon from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-tiktok.svg?url';
import TikTokIconDisabled from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-tiktok-disabled.svg?url';
import TikTokBCIcon from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-bc.svg?url';
import TikTokBCIconDisabled from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-bc-disabled.svg?url';
import TikTokTtsIcon from '@tt4b/ttam-assets/src/svgs/creative/vi-icon-tts-tt.svg?url';

import { i18n } from './../../i18n';

export const IDENTITY_DISABLED_SWITCH_MAP = {
  DISABLED_NOT_CONTAIN_TT_POSITION: i18n.t('module_identity_switch_disabled_not_contain_tt_reason'), // 当前您选择的版位中未包含TikTok，因此暂时无法投放原生广告
  DISABLED_NOT_SUPPORT_ACO: i18n.t('module_identity_switch_disabled_aco_reason'), // 程序化创意暂时不支持投放原生广告
  DISABLED_OBJECTIVE_NOT_SUPPORT_NATIVE: i18n.t('module_identity_switch_disabled_objective_not_native_reason'), // 当前您的推广目标暂时不支持投放原生广告
  DISABLED_OBJECTIVE_NOT_SUPPORT_NORMAL: i18n.t('module_identity_switch_disabled_objective_not_normal_reason'), // 当前推广目标不支持投放导流广告
  DISABLED_IS_FIRST_CREATE_CUSTOM: i18n.t('module_identity_switch_disabled_is_first_create_custom_reason'), // 不存在custom账号（需要首次创建）
  DISABLED_NORMAL_TO_NATIVE: i18n.t('module_identity_switch_disabled_normal_to_native_reason'), // 暂时不支持导流广告和原生广告进行切换
  DISABLED_NATIVE_TO_NORMAL: i18n.t('module_identity_switch_disabled_native_to_normal_reason'), // 暂时不支持原生广告和导流广告进行切换
};

export const IDENTITY_TYPE_CONFIG = {
  [IDENTITY_TYPE_MAP.UN_SET]: {
    name: i18n.t('module_creative_custom_identity'), // 可用时的展示名称
    unavailableName: i18n.t('module_creative_custom_identity'), // 不可用时的展示名称
    icon: '',
    disabledIcon: '',
  },
  [IDENTITY_TYPE_MAP.FAKE_USER]: {
    name: i18n.t('module_creative_custom_identity'),
    unavailableName: i18n.t('module_creative_custom_identity'),
    icon: '',
    disabledIcon: '',
  },
  [IDENTITY_TYPE_MAP.AUTH_CODE_USER]: {
    name: i18n.t('module_creative_bc_tta_identity_account_describe'),
    unavailableName: i18n.t('module_creative_authorized_tiktok_account'),
    icon: TikTokIcon,
    disabledIcon: TikTokIconDisabled,
  },
  [IDENTITY_TYPE_MAP.TT_USER]: {
    name: i18n.t('module_creative_tiktok_business_account'), // 只有TTBA name和unavailableName是不同的
    unavailableName: i18n.t('module_creative_tiktok_account'),
    icon: TikTokIcon,
    disabledIcon: TikTokIconDisabled,
  },
  [IDENTITY_TYPE_MAP.BC_AUTH_TT]: {
    name: i18n.t('module_creative_bc_identity_account_describe'),
    unavailableName: i18n.t('module_creative_bc_identity_account_describe'),
    icon: TikTokBCIcon,
    disabledIcon: TikTokBCIconDisabled,
  },
  [IDENTITY_TYPE_MAP.TTS_TT]: {
    name: i18n.t('module_creative_tts_identity_account_describe'),
    unavailableName: i18n.t('module_creative_tts_identity_account_describe'),
    icon: TikTokTtsIcon,
    disabledIcon: TikTokTtsIcon,
  },
  [IDENTITY_TYPE_MAP.AFFILIATE]: {
    name: i18n.t('module_creative_affiliate_identity_account_describe'),
    unavailableName: i18n.t('module_creative_affiliate_identity_account_describe'),
    icon: TikTokTtsIcon,
    disabledIcon: TikTokTtsIcon,
  },
};

/** 需要展示identity账号不可用的类型列表 */
export const SHOW_IDENTITY_AVAILABLE_LIST = [
  IDENTITY_AVAILABLE_STATUS.NO_VALID_BIND_ACCOUNT,
  IDENTITY_AVAILABLE_STATUS.SCOPE_UNAVAILABLE,
  IDENTITY_AVAILABLE_STATUS.IS_PRIVATE_ACCOUNT,
  IDENTITY_AVAILABLE_STATUS.NOT_BUSINESS_ACCOUNT,
];

export const CUSTOM_IDENTITY_OPERATOR = {
  ADD: 'add',
  EDIT: 'edit',
};
